// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  border-radius: 10px;
  background: var(--ion-item-background);
  margin: 16px 0;
  overflow: hidden;
}
ion-grid ion-row {
  border-bottom: 1px solid var(--ion-item-border-color);
  margin: 0px 16px;
}
ion-grid ion-row ion-col:nth-child(2) {
  text-align: right;
}
ion-grid ion-row:last-child {
  border-bottom: 0;
}
ion-grid h6 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #747889;
}
ion-grid h3 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin-top: 0;
}
ion-grid .in-active {
  color: #FF8686;
}
ion-grid .active {
  color: #63EDBB;
}

.add-task-follower-select ionic-selectable {
  display: none;
}

.ion-checkbox {
  --border-color: #C6C6C6;
  --border-color-checked: var(--ion-color-primary);
  --border-radius: 5px;
  --size: 26px;
  margin-right: 10px;
}

ion-item.checkbox {
  height: 45px;
  padding: 0px 0px 45px 0px;
  --ion-padding-top: 0;
  --ion-padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
  border-radius: 0;
}

.progress-outer {
  width: 96%;
  text-align: center;
  background-color: #F3F3F3;
  color: #fff;
  border-radius: 19px;
}

.progress-inner {
  min-width: 15%;
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  padding: 4px;
  border-radius: 19px;
  font-size: 12px;
  transition: width 0.3s;
}

.bg-progress-bar {
  background: var(--ion-color-default) !important;
}

.progress-inner-color {
  color: var(--ion-text-color) !important;
}

.time-sheet-h6 {
  font-size: 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/tasks/view/view.page.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,sCAAA;EACA,cAAA;EACA,gBAAA;AACJ;AAAI;EACI,qDAAA;EACA,gBAAA;AAER;AAAQ;EACI,iBAAA;AAEZ;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADR;AAII;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AAFR;AAKI;EACI,cAAA;AAHR;AAKI;EACI,cAAA;AAHR;;AAOA;EACI,aAAA;AAJJ;;AAOA;EACI,uBAAA;EACA,gDAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,cAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EAEA,eAAA;EACA,sBAAA;AALJ;;AAOA;EACI,+CAAA;AAJJ;;AAOA;EACI,uCAAA;AAJJ;;AAMA;EACI,0BAAA;AAHJ","sourcesContent":["ion-grid {\n    border-radius: 10px;\n    background: var(--ion-item-background);\n    margin: 16px 0;\n    overflow: hidden;\n    ion-row {\n        border-bottom: 1px solid var(--ion-item-border-color);\n        margin: 0px 16px;\n        \n        ion-col:nth-child(2) {\n            text-align: right;\n        }\n    }\n\n    ion-row:last-child {\n        border-bottom: 0;\n    }\n\n    h6 {\n        font-family: 'Roboto';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 16px;\n        color: #747889;\n    }\n    \n    h3 {\n        font-family: 'Roboto';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19px;\n        margin-top: 0;\n    }\n\n    .in-active {\n        color: #FF8686;\n    }\n    .active {\n        color: #63EDBB;\n    }\n}\n\n.add-task-follower-select ionic-selectable {\n    display: none;\n}\n\n.ion-checkbox {\n    --border-color: #C6C6C6;\n    --border-color-checked: var(--ion-color-primary);\n    --border-radius: 5px;\n    --size: 26px;\n    margin-right: 10px;\n}\n\nion-item.checkbox {\n    height: 45px;\n    padding: 0px 0px 45px 0px;\n    --ion-padding-top: 0;\n    --ion-padding-bottom: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n    border-radius: 0;\n}\n\n.progress-outer {\n    width: 96%;\n    text-align: center;\n    background-color: #F3F3F3;\n    color: #fff;\n    border-radius: 19px;\n}\n\n.progress-inner {\n    min-width: 15%;\n    width: 90%;\n    white-space: nowrap;\n    overflow: hidden;\n    padding: 4px;\n    border-radius: 19px;\n    // background: var(--ion-color-default);\n    font-size: 12px;\n    transition: width .3s;\n}\n.bg-progress-bar {\n    background: var(--ion-color-default) !important;\n    \n}\n.progress-inner-color{\n    color: var(--ion-text-color) !important;\n}\n.time-sheet-h6{\n    font-size: 12px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
